import React, { useState, useEffect } from 'react';
import QrScanner from 'react-qr-scanner';
import { QRCodeCanvas } from 'qrcode.react'; // Import QRCodeCanvas
import { useParams } from 'react-router-dom';

const RedeemTicketPage = () => {
  const [qrData, setQrData] = useState(null);
  const [err, setErr] = useState('');
  const [RedemptionStatus, setRedemptionStatus] = useState(false);
  const [inputCode, setInputCode] = useState(true);
  const [bookingDetails, setbookingDetails] = useState({});
  const [ticketId, setTicketId] = useState('');
  const [auth, setAuth] = useState(false);

  const [code, setCode] = useState('');

  useEffect(() => {
    // console.log(ticketId)
    // if (!ticketId){
    //   return
    // }



  }, [])

  const checkTicket = () => {
    console.log(ticketId)
    if (ticketId === '') {
      setErr('input Booking ID')
      return
    }

    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");


      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
      };

      fetch(`https://adrenalinehub-v1.onrender.com/api/v1/booking/redeem?ticketId=${ticketId}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          // console.log(result)
          if (result.success) {
            setbookingDetails(result.data)
            setInputCode(false)
          } else {
            setErr(result.message);
          }
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error)
    }
  }

  const redeemTicket = async (ticketId) => {
    if (code !== '7989') {
      alert('You are not authorized')
      return
    }
    try {
      // Simulate API call to validate the QR code data
      const response = await fetch(`${'https://adrenalinehub-v1.onrender.com'}/api/v1/booking/redeem/?ticketId=${ticketId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      const result = await response.json();

      if (result.success) {
        setRedemptionStatus(result.message);
      } else {
        setRedemptionStatus(result.message);
      }

      setAuth(false)
    } catch (error) {
      console.error('Error redeeming ticket:', error);
      setRedemptionStatus('An error occurred while redeeming the ticket.');
    }
  };


  return (
    <>
      {inputCode ?
        <div className='w-full h-full bg-[#000000c1] fixed top-0 flex flex-col items-center justify-center'>
          {err && <p className="mt-2 text-sm text-red-500">{err}</p>}
          <div className="max-w-md mx-auto mt-6 p-4 bg-white rounded-lg shadow-md text-center flex flex-col items-center justify-center">
            <header className="text-center mb-8">
              <h1 className="text-3xl font-bold text-green-600">Booking ID</h1>
            </header>

            <input className='border outline-none rounded p-4 text-center font-bold text-2xl' 
            // maxLength={4} 
            placeholder='Input booking ID' onChange={(e) => setTicketId(e.target.value)} />

            <button onClick={() => {
              checkTicket(ticketId)
            }} className='bg-green-500 text-center py-2 px-4 mt-6 rounded font-bold'>Check</button>

          </div>
        </div>
        :
        <>
          {auth &&
            <div className='w-full h-full bg-[#000000c1] fixed top-0 flex flex-col items-center justify-center'>
              <div className="max-w-md mx-auto mt-6 p-4 bg-white rounded-lg shadow-md text-center flex flex-col items-center justify-center">
                <header className="text-center mb-8">
                  <h1 className="text-3xl font-bold text-green-600">Verify</h1>
                </header>

                <input className='border outline-none rounded p-4 text-center font-bold text-2xl' maxLength={4} placeholder='Verify' onChange={(e) => setCode(e.target.value)} type='password' />

                <button onClick={() => {
                  redeemTicket(bookingDetails?.transactionId)
                }} className='bg-green-500 text-center py-2 px-4 mt-6 rounded font-bold'>Redeem</button>

              </div>
            </div>}


          <div className="max-w-md mx-auto mt-6 p-4 bg-white rounded-lg shadow-md text-center">
            <header className="text-center mb-8">
              <h1 className="text-3xl font-bold text-green-600">Redeem Ticket</h1>
            </header>

            <p className="text-red-600 mb-4 text-center font-bold">{RedemptionStatus}</p>

            <section className="mb-8 text-left px-6">
              <h2 className="text-2xl font-semibold text-gray-800">Booking Details:</h2>
              <p className="text-lg text-gray-700"><strong>Booking ID:</strong> {bookingDetails?.transactionId}</p>
              <p className="text-lg text-gray-700"><strong>Booking Date:</strong> {bookingDetails?.date}</p>
              <p className="text-lg text-gray-700"><strong>Time Slot:</strong> {bookingDetails?.startTime + ' - ' + bookingDetails?.endTime}</p>
              <p className="text-lg text-gray-700"><strong>Number of Players:</strong> {bookingDetails?.numPlayers}</p>
              <p className="text-lg text-red-600"><strong className='text-gray-700'>Ticket Status:</strong> {bookingDetails?.status}</p>

              <p className="text-lg text-gray-700"><strong>Total Amount Paid:</strong> ₦{bookingDetails?.totalPrice}</p>
            </section>

            <div className="mb-8">

            </div>

            <div className='flex flex-col items-center justify-center'>
              <QRCodeCanvas value={bookingDetails?.transactionId?.toString()} size={256} />
            </div>

            <button onClick={() => {
              setAuth(true)
            }} className='bg-green-500 text-center py-2 px-4 mt-6 rounded font-bold'>Redeem</button>

          </div>
        </>}

    </>
  );
};

export default RedeemTicketPage;
